<nz-layout class="layout">
  <nz-header>
    <div class="logo"
      [ngClass]="currentUrl.includes('overview') || currentUrl.includes('dashboard') || currentUrl.includes('investments') || currentUrl.includes('expenses') || currentUrl.includes('transfers') || currentUrl.includes('reports') || currentUrl.includes('projections') || currentUrl.includes('cashflow') || currentUrl.includes('/security') ?'setting-menu':'reports-menu'">
      <a [routerLink]="canViewOverview ? '/brooklyn/overview' : landingURL"><img class="setting-menu-logo"
          src="assets/images/Brooklynlogo.png">
        <img src="assets/images/Brooklyn.png" class="reports-menu-logo">
      </a>
    </div>

    <div class="mobile-menu">
      <button class="BurgerMenu" type="button">
        <span class="FirstBar"></span>
        <span class="SecondBar"></span>
        <span class="ThirdBar"></span>
      </button>
    </div>
    <h4 class="paydev-testing-text">{{ userDetails ? userDetails['firstName'] : ''}} {{userDetails ?
      userDetails['lastName'] : ''}}</h4>

    <div class="header-right">
      <ul>
        <li
          *ngIf="canViewUsers || canViewRoles || canViewAgency || canViewAccount || canViewAccountTypes || canViewSites || canViewSuppliers || canViewReps || canViewVendors || canViewTerms || canViewMaintainance || canViewAnnouncement || canViewliabilities">
          <a [routerLink]="settingUrl"><img class="notification-setting-icon" src="./assets/images/settings.svg">
            Settings </a>
        </li>
        <li> <a class="d-flex align-i-c user-menu-trigger" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu"
            nzPlacement="bottomRight" nzOverlayClassName="user-menu-overlay" [nzBackdrop]="true"
            (nzVisibleChange)="isUserMenuOpen = $event">
            <span class="user-menu-trigger-avatar">
              <img *ngIf="userAvatarUrl" [src]="userAvatarUrl" (error)="onAvatarLoadFailed()" alt="">
              <ng-container *ngIf="!userAvatarUrl">{{userInitials}}</ng-container>
            </span>
            <span class="user-menu-trigger-name">{{ userFullName }}</span>
            <span class="down-icon" nz-icon nzType="down"></span>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu class="profile-dropdown">
              <li class="user-menu-header">
                <span class="user-menu-avatar">
                  <img *ngIf="userAvatarUrl" [src]="userAvatarUrl" (error)="onAvatarLoadFailed()" alt="">
                  <ng-container *ngIf="!userAvatarUrl">{{userInitials}}</ng-container>
                </span>
                <span class="user-menu-identity">
                  <span class="user-menu-name">{{ userFullName }}</span>
                  <span class="user-menu-email" nz-tooltip [nzTooltipTitle]="userDetails ? userDetails['email'] : ''"
                    nzTooltipPlacement="bottom">{{ userDetails ? userDetails['email'] : '' }}</span>
                </span>
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="showProfileDrawer()"><a><img class="icon-width"
                    src="./assets/images/My-Profile.svg"><span>My Profile </span></a></li>
              <li nz-menu-divider></li>
              <li class="user-menu-group-label">Security</li>
              <li nz-menu-item><a [routerLink]="'/brooklyn/security/authentication'"><span class="icon-width" nz-icon
                    nzType="safety" nzTheme="outline"></span><span>Authentication</span></a></li>
              <li nz-menu-item><a [routerLink]="'/brooklyn/security/devices'"><span class="icon-width" nz-icon
                    nzType="laptop" nzTheme="outline"></span><span>Authorized devices</span></a></li>
              <li nz-menu-item><a [routerLink]="'/brooklyn/security/terms'"><span class="icon-width" nz-icon
                    nzType="file-text" nzTheme="outline"></span><span>Terms</span></a></li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="Logout()"><a><img class="icon-width" src="./assets/images/Log-out.svg">Log
                  out</a> </li>
            </ul>
          </nz-dropdown-menu>
        </li>
      </ul>
    </div>
  </nz-header>
  <nz-layout class="right-layout">
    <nz-sider class="side-menu-width side-menu-second" nzTheme="light"
      *ngIf="currentUrl.includes('suppliers') || currentUrl.includes('reps') || currentUrl.includes('vendors') || currentUrl.includes('roles') || currentUrl.includes('agency') || currentUrl.includes('users') || currentUrl.includes('account') || currentUrl.includes('sites') || currentUrl.includes('maintenance') || currentUrl.includes('announcements') || currentUrl.includes('general') || currentUrl.includes('resources') || currentUrl.includes('badges') || currentUrl.includes('types') || currentUrl.includes('under-review') || currentUrl.includes('/brooklyn/terms') || currentUrl.includes('program')">
      <div class="sider-menu">
        <ul nz-menu nzMode="inline">
          <li *ngIf="canViewUsers" nz-menu-item [nzSelected]="currentUrl.includes('users')"
            [routerLink]="'/brooklyn/users'"><a>Users</a>
          </li>
          <li nz-menu-item *ngIf="canViewRoles" [nzSelected]="currentUrl.includes('roles')"
            [routerLink]="'/brooklyn/roles'"><a>Roles</a>
          </li>
          <li nz-menu-item *ngIf="canViewAgency" [nzSelected]="currentUrl.includes('agency')"><a
              [routerLink]="'/brooklyn/agency'">Agency</a>
          </li>
          <li nz-menu-item *ngIf="canViewAccount" [nzSelected]="currentUrl.includes('accounts')"
            [routerLink]="'/brooklyn/accounts'">
            <a>Accounts</a>
          </li>
          <li nz-menu-item *ngIf="canViewSites" [nzSelected]="currentUrl.includes('sites')"
            [routerLink]="'/brooklyn/sites'"><a>Sites</a>
          </li>
          <li nz-menu-item *ngIf="canViewSuppliers" [nzSelected]="currentUrl.includes('suppliers')"
            [routerLink]="'/brooklyn/suppliers'">
            <a>Suppliers</a>
          </li>
          <li nz-menu-item *ngIf="canViewReps" [nzSelected]="currentUrl.includes('reps')"
            [routerLink]="'/brooklyn/reps'"><a>Reps</a></li>
          <li nz-menu-item *ngIf="canViewVendors" [nzSelected]="currentUrl.includes('vendors')"
            [routerLink]="'/brooklyn/vendors'">
            <a>Vendors</a>
          </li>
          <li nz-menu-item *ngIf="canViewResources" [nzSelected]="currentUrl.includes('resources')"
            [routerLink]="'/brooklyn/resources'">
            <a>Resources</a>
          </li>
          <li nz-menu-item *ngIf="canViewAccountTypes" [nzSelected]="currentUrl.includes('types')"
            [routerLink]="'/brooklyn/types'">
            <a>Types</a>
          </li>
          <li nz-menu-item *ngIf="canViewRetailPrograms" [nzSelected]="currentUrl.includes('programs')"
            [routerLink]="'/brooklyn/programs'">
            <a>Programs</a>
          </li>
          <li nz-menu-item *ngIf="canViewBadges" [nzSelected]="currentUrl.includes('badges')"
            [routerLink]="'/brooklyn/badges'">
            <a>Badges</a>
          </li>
          <li nz-menu-item *ngIf="canViewUnderReviews" [nzSelected]="currentUrl.includes('under-review')"
            [routerLink]="'/brooklyn/under-review'">
            <a>Under Review</a>
          </li>
          <li nz-menu-item *ngIf="canViewTerms" [nzSelected]="currentUrl.includes('terms')"
            [routerLink]="'/brooklyn/terms'">
            <a>Terms</a>
          </li>
          <li nz-menu-item *ngIf="canViewMaintainance" [nzSelected]="currentUrl.includes('maintenance')"
            [routerLink]="'/brooklyn/maintenance'">
            <a>Maintenance</a>
          </li>
          <li nz-menu-item *ngIf="canViewAnnouncement" [nzSelected]="currentUrl.includes('announcements')"
            [routerLink]="'/brooklyn/announcements'">
            <a>Announcements</a>
          </li>
          <li nz-menu-item *ngIf="canViewliabilities" [nzSelected]="currentUrl.includes('general')"
            [routerLink]="'/brooklyn/general'">
            <a>General</a>
          </li>
        </ul>
        <!-- <nz-divider></nz-divider> -->
        <ul nz-menu nzMode="inline" class="second-menu">
          <li nz-menu-item nzDisabled><a>Shops</a></li>
          <li nz-menu-item nzDisabled><a>Offer</a></li>
          <li nz-menu-item nzDisabled><a>Links</a></li>
          <li nz-menu-item nzDisabled><a>Promo</a></li>
          <li nz-menu-item nzDisabled><a>Tutorial</a></li>
          <li nz-menu-item nzDisabled><a>Holidays</a></li>
        </ul>
      </div>
      <div class="footer cl-white"><span nz-icon class="pr-2px" nzType="copyright"
          nzTheme="outline"></span>{{currentYear}} | PayBev LLC</div>

    </nz-sider>
    <nz-sider class="side-menu-width" nzTheme="light" *ngIf="currentUrl.includes('/security')">
      <div class="sider-menu">
        <p class="sider-group-label">Security</p>
        <ul nz-menu nzMode="inline">
          <li nz-menu-item [nzSelected]="currentUrl.includes('/security/authentication') ||
            currentUrl.includes('/security/password') || currentUrl.includes('/security/passkey')"
            [routerLink]="'/brooklyn/security/authentication'"><a><span class="menu-icon"><span nz-icon
                  nzType="safety" nzTheme="outline" class="menuIcon"></span></span>Authentication</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('/security/devices')"
            [routerLink]="'/brooklyn/security/devices'"><a><span class="menu-icon"><span nz-icon nzType="laptop"
                  nzTheme="outline" class="menuIcon"></span></span>Authorized devices</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('/security/terms')"
            [routerLink]="'/brooklyn/security/terms'"><a><span class="menu-icon"><span nz-icon nzType="file-text"
                  nzTheme="outline" class="menuIcon"></span></span>Terms</a></li>
        </ul>
      </div>
      <div class="footer"><span nz-icon nzType="copyright" nzTheme="outline" class="pr-2px"></span>{{currentYear}} |
        PayBev LLC</div>
    </nz-sider>
    <nz-sider class="side-menu-width"
      *ngIf="currentUrl.includes('overview') || currentUrl.includes('dashboard') || currentUrl.includes('investments') || currentUrl.includes('expenses') || currentUrl.includes('transfers') || currentUrl.includes('reports') || currentUrl.includes('projections') || currentUrl.includes('cashflow')">
      <div class="sider-menu">

        <ul nz-menu nzMode="inline">
          <li class="newOptions" style="padding-bottom:40px !important"><a nz-popover nzPopoverTitle="Title"
              [(nzPopoverVisible)]="visible" (nzPopoverVisibleChange)="change($event)" nzPopoverTrigger="click"
              [nzPopoverContent]="contentTemplate" nzPopoverPlacement="bottomLeft"
              nzPopoverOverlayClassName="linksPopOver">
              <span nz-icon nzType="plus" nzTheme="outline"></span> New
            </a></li>
          <ng-template #contentTemplate class="new-modal">
            <div *ngIf="!isShowLess">
              <div class="d-flex customPopOver new-modal">
                <nz-list nzSize="small" *ngIf="canViewEstimates || canViewBTs || canViewSuppliers || canViewReps">
                  <nz-list-header>CUSTOMERS</nz-list-header>
                  <nz-list-item class="cursor" *ngIf="canViewEstimates"
                    (click)="navigateToSecondTab('investments', 1);visible=false">Estimates</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewEstimates"
                    (click)="navigateToSecondTab('investments');visible=false">Invoices</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewSuppliers" routerLink="/brooklyn/suppliers"
                    (click)="visible=false">Suppliers</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewReps" routerLink="/brooklyn/reps"
                    (click)="visible=false">Reps</nz-list-item>
                </nz-list>
                <nz-list nzSize="small" *ngIf="canViewBills || canViewBTs || canViewVendors">
                  <nz-list-header>VENDORS</nz-list-header>
                  <nz-list-item class="cursor" *ngIf="canViewBills" routerLink="/brooklyn/expenses"
                    (click)="visible=false">Bills</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewBills" (click)="navigateToSecondTab('expenses')"
                    (click)="visible=false">Expenses</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewBTs" routerLink="/brooklyn/transfers"
                    (click)="visible=false">Internal Transfers</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewVendors" routerLink="/brooklyn/vendors"
                    (click)="visible=false">Vendors</nz-list-item>
                </nz-list>
                <nz-list nzSize="small"
                  *ngIf="canViewUsers || canViewRoles || canViewAgency || canViewAccount || canViewSites">
                  <nz-list-header>OTHER</nz-list-header>
                  <nz-list-item class="cursor" *ngIf="canViewUsers" routerLink="/brooklyn/users"
                    (click)="visible=false">Users</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewRoles" routerLink="/brooklyn/roles"
                    (click)="visible=false">Roles</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewAgency" routerLink="/brooklyn/agency"
                    (click)="visible=false">Agency</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewAccount" routerLink="/brooklyn/accounts"
                    (click)="visible=false">Accounts</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewSites" routerLink="/brooklyn/sites"
                    (click)="visible=false">Sites</nz-list-item>
                </nz-list>
                <nz-list nzSize="small" *ngIf="canViewMaintainance || canViewAnnouncement">
                  <nz-list-header>SETTINGS</nz-list-header>
                  <nz-list-item class="cursor" *ngIf="canViewMaintainance" routerLink="/brooklyn/maintenance"
                    (click)="visible=false">Maintenance</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewAnnouncement" routerLink="/brooklyn/announcements"
                    (click)="visible=false">Announcements</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewAnnouncement" routerLink="/brooklyn/general"
                    (click)="visible=false">General</nz-list-item>
                </nz-list>
              </div>
            </div>
            <div *ngIf="isShowLess">
              <div class="d-flex customPopOver">
                <nz-list nzSize="small">
                  <nz-list-item class="cursor" *ngIf="canViewEstimates"
                    (click)="navigateToSecondTab('investments', 1);visible=false">Estimates</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewEstimates"
                    (click)="navigateToSecondTab('investments');visible=false">Invoices</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewBills" routerLink="/brooklyn/expenses"
                    (click)="visible=false">Bills</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewBills" (click)="navigateToSecondTab('expenses')"
                    (click)="visible=false">Expenses</nz-list-item>
                  <nz-list-item class="cursor" *ngIf="canViewBTs" (click)="navigateToSecondTab('transfers', 0)"
                    (click)="visible=false">Internal Transfers</nz-list-item>
                </nz-list>
              </div>
            </div>
            <hr />
            <a class="show-less-more-btn" (click)="clickMe()" nz-button>{{isShowLess ? 'Show more' : 'Show less'}}</a>
          </ng-template>
          <li nz-menu-item [nzSelected]="currentUrl.includes('overview')" *ngIf="canViewOverview"><a
              [routerLink]="'/brooklyn/overview'"><span class="menu-icon">
                <!--<img src="./assets/images/Overview.svg">-->
                <span nz-icon nzType="monitor" nzTheme="outline" class="menuIcon"></span></span>Overview</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('cashflow')" *ngIf="canViewCashflow"><a class="cash-flow-link"
              [routerLink]="'/brooklyn/cashflow'"><span class="menu-icon">
                <span class="menuIcon">
                  <svg class="cash-flow-icon" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 108.05">
                    <title>cash-flow</title>
                    <path 
                      d="M2.05,44.88a2,2,0,0,0-1.72.8c-.86,1.26.13,2.52.94,3.44,2.31,2.64,8.9,11.35,10.14,12.82a2,2,0,0,0,3.14,0c1.22-1.41,7.66-9.71,10.13-12.38.86-1,2.14-2.3,1.23-3.68a2.05,2.05,0,0,0-1.7-.83L18,45a44.5,44.5,0,0,1,84.66-8.1l8.81-3.66A54,54,0,0,0,8.28,44.94l-6.23-.06ZM56.33,31.11V25.9h8.76V31A71.91,71.91,0,0,1,77,32.65V42q-3.15-.24-7.09-.39t-7.16-.15a22,22,0,0,0-3.43.24c-4.6.74-4.65,6.78,1.3,6.78H65.1a17.69,17.69,0,0,1,8,1.61,11.19,11.19,0,0,1,4.79,4.36,12.1,12.1,0,0,1,1.62,6.27v2q0,5.74-2.27,8.78a11.05,11.05,0,0,1-6.44,4.08,27.19,27.19,0,0,1-5.69,1v5.65H56.33V76.54A63.13,63.13,0,0,1,44.4,74.87V65.54c5.19.41,10.49.55,15.69.55a18.86,18.86,0,0,0,3.77-.31c4.64-.93,3.89-6.17-.55-6.17H59.68q-7.95,0-12.06-3.09T43.51,46.16v-2q0-6.66,4.52-10a16,16,0,0,1,8.3-3.09Zm58.6,31.09A54,54,0,0,1,10.28,71.11l9-3a44.51,44.51,0,0,0,85.91-5.71l-6.5.14A2,2,0,0,1,97,61.77c-1-1.35.29-2.74,1.12-3.71,2.39-2.75,8.58-11.24,9.75-12.69a2,2,0,0,1,1.55-.79,2,2,0,0,1,1.59.73c1.29,1.43,8.14,9.94,10.53,12.51.83.89,1.86,2.12,1,3.4a2,2,0,0,1-1.7.86l-5.95.12Z" />
                  </svg>
              </span>
              </span>Cash Flow</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('dashboard')" *ngIf="canViewDashboard"><a
              [routerLink]="'/brooklyn/dashboard'"><span class="menu-icon">
                <!--<img src="./assets/images/Dashboard.svg">-->
                <span nz-icon nzType="appstore" nzTheme="outline" class="menuIcon"></span></span>Dashboard</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('investments')" *ngIf="canViewEstimates"><a
              [routerLink]="'/brooklyn/investments'"><span class="menu-icon">
                <!--<img src="./assets/images/Investments.svg">-->
                <span nz-icon nzType="dollar" nzTheme="outline" class="menuIcon"></span>
              </span>Investments</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('expenses')" *ngIf="canViewBills"><a
              [routerLink]="'/brooklyn/expenses'"><span class="menu-icon">
                <!--<img src="./assets/images/Expenses.svg">-->
                <span nz-icon nzType="wallet" nzTheme="outline" class="menuIcon"></span></span>Expenses</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('transfers')" *ngIf="canViewBTs"><a
              [routerLink]="'/brooklyn/transfers'"><span class="menu-icon">
                <!-- <img src="./assets/images/Transfers.svg"> -->
                <span nz-icon nzType="retweet" nzTheme="outline" class="menuIcon"></span></span>Transfers</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('projections')" *ngIf="canViewProjections"><a
              [routerLink]="'/brooklyn/projections'"><span class="menu-icon">
                <span nz-icon nzType="fund-projection-screen" nzTheme="outline" class="menuIcon"></span></span>Projections</a></li>
          <li nz-menu-item [nzSelected]="currentUrl.includes('reports')" *ngIf="canViewReport"><a
              [routerLink]="'/brooklyn/reports'"><span class="menu-icon">
                <!-- <img src="./assets/images/Reports.svg"> -->
                <span nz-icon nzType="file-text" nzTheme="outline" class="menuIcon"></span></span>Reports</a></li>
        </ul>
      </div>
      <div class="footer"><span nz-icon nzType="copyright" nzTheme="outline" class="pr-2px"></span>{{currentYear}} |
        PayBev LLC</div>
    </nz-sider>
    <nz-content>
      <router-outlet>
      </router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>

<div class="user-menu-backdrop" *ngIf="isUserMenuOpen"></div>
<app-myprofile *ngIf="isVisibleProfileDrawer" (hideProfileDrawer)="hideProfileDrawer($event)"></app-myprofile>
<script>
  function bindScript() {
    $(".BurgerMenu").click(function () {
      $("body").toggleClass("active-menu");
    });
  }
</script>